"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const uuid_1 = require("uuid");
const pluralize_1 = __importDefault(require("pluralize"));
const clsx_1 = __importDefault(require("clsx"));
const SongwriterCatalogBuilderToggle_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterCatalogBuilderScene/SongwriterCatalogBuilderResults/SongwriterCatalogBuilderToggle"));
const SongwriterCatalogBuilderTable = ({ data, onTitleClick, linkedWriterIpIds, onWriterToggle, }) => (react_1.default.createElement("table", { className: 'songwriter-link-table' },
    react_1.default.createElement("colgroup", null,
        react_1.default.createElement("col", { className: 'songwriter-name-col' }),
        react_1.default.createElement("col", { className: 'songwriter-toggle-col' })),
    react_1.default.createElement("thead", null,
        react_1.default.createElement("tr", null,
            react_1.default.createElement("td", null, "Writer Name"),
            react_1.default.createElement("td", null, "Catalog Status"))),
    react_1.default.createElement("tbody", null, data.map((writer) => {
        var _a;
        return (react_1.default.createElement("tr", { key: (_a = writer.ipId) !== null && _a !== void 0 ? _a : (0, uuid_1.v4)() },
            react_1.default.createElement("td", null,
                react_1.default.createElement("div", { className: 'writer-data' },
                    react_1.default.createElement("div", { className: 'writer-name-titles' },
                        react_1.default.createElement("span", { className: 'writer-name' },
                            writer.name,
                            ":"),
                        react_1.default.createElement("span", { className: (0, clsx_1.default)('writer-titles', !!writer.worksCount && 'clickable'), onClick: () => !!writer.worksCount && onTitleClick(writer) }, (0, pluralize_1.default)('title', writer.worksCount, true))),
                    react_1.default.createElement("div", { className: 'writer-ipi' },
                        react_1.default.createElement("span", null, "IPI:"),
                        " ",
                        writer.ipiNumber))),
            react_1.default.createElement("td", null,
                react_1.default.createElement(SongwriterCatalogBuilderToggle_1.default, { onClick: (isLinked) => {
                        onWriterToggle(isLinked, Number(writer.ipId));
                    }, checked: !!linkedWriterIpIds.find((writerIpid) => writerIpid === Number(writer.ipId)) }))));
    }))));
exports.default = (0, mobx_react_1.observer)(SongwriterCatalogBuilderTable);
